import defaultCarImg from '../Assets/hero-banner-bg.png';
import siteLogo from '../Assets/carsinfinite-logo.png';

export const SITE_LOGO = siteLogo;
export const SITE_LOGO_ALT = 'Cars Infinite';

export const getAssetBase = () => {
  let api = process.env.REACT_APP_API_URL;
  if (!api && typeof window !== 'undefined' && window.location.hostname === 'localhost') {
    api = 'http://localhost:8000/api';
  }
  api = api || 'https://carsinfinite.com/api';
  return api.replace(/\/api\/?$/, '');
};

export const assetUrl = (filename) => `${getAssetBase()}/api/assets/${filename}`;

export const DEFAULT_CAR_IMAGE = defaultCarImg;

const BAD_PATTERNS = [/placehold\.co/i, /^pic\d*$/i, /^pic$/i];

export const isBadImage = (url) => {
  if (url == null) return true;
  if (typeof url !== 'string') return true;
  const t = url.trim();
  if (!t) return true;
  if (BAD_PATTERNS.some((re) => re.test(t))) return true;
  return false;
};

export const resolveImage = (url, fallback = DEFAULT_CAR_IMAGE) => {
  if (!isBadImage(url)) return url;
  return fallback || DEFAULT_CAR_IMAGE;
};

export const resolveImages = (images, fallbackList = [DEFAULT_CAR_IMAGE]) => {
  const list = Array.isArray(images) ? images.filter((i) => !isBadImage(i)) : [];
  if (list.length) return list;
  const fb = Array.isArray(fallbackList) ? fallbackList.filter((i) => !isBadImage(i)) : [];
  return fb.length ? fb : [DEFAULT_CAR_IMAGE];
};

export const getRowImage = (row, keys = ['image', 'profile_image']) => {
  for (const key of keys) {
    if (row[key] && !isBadImage(row[key])) return row[key];
  }
  if (Array.isArray(row.images) && row.images.length) {
    return resolveImage(row.images[0]);
  }
  if (row.carousel?.[0]?.image) return resolveImage(row.carousel[0].image);
  return null;
};
